var selectors = {
  drawerWrappper: '[data-drawer]',
  underlay: '[data-drawer-underlay]',
  stagger: '[data-stagger-animation]',
  drawerToggle: 'data-drawer-toggle',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
};

var classes = {
  isVisible: 'drawer--visible',
  displayNone: 'display-none',
};

var sections = {};

class Drawer {
  constructor(el) {
    this.drawer = el;
    this.underlay = this.drawer.querySelector(selectors.underlay);
    this.key = this.drawer.dataset.drawer;
    const btnSelector = `[${selectors.drawerToggle}='${this.key}']`;
    this.buttons = document.querySelectorAll(btnSelector);
    this.staggers = this.drawer.querySelectorAll(selectors.stagger);

    this.connectToggle();
    this.connectDrawer();
    this.closers();
    this.staggerChildAnimations();

  }

  unload() {
    // wipe listeners
  }

  connectToggle() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        this.drawer.dispatchEvent(new CustomEvent('theme:menu:toggle', {
          bubbles: false,
        }));
      }.bind(this));
    });
  }

  connectDrawer() {
    this.drawer.addEventListener('theme:menu:toggle', function() {
      if (this.drawer.classList.contains(classes.isVisible)) {
        this.hideDrawer();
      } else {
        this.showDrawer();
      }
    }.bind(this));
  }

  staggerChildAnimations() {
    this.staggers.forEach((el) => {
      const children = el.querySelectorAll(':scope > * > [data-animates]');
      children.forEach((child, index) => {
        child.style.transitionDelay = `${((index * 50) + 10)}ms`;
      });
    });
  }

  watchFocus(evt) {
    let drawerInFocus = this.drawer.contains(evt.target);
    if (!drawerInFocus) {
      this.hideDrawer();
    }
  }

  closers() {
    this.drawer.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.ESCAPE) { return; }
      this.hideDrawer();
      this.buttons[0].focus();
    }.bind(this));

    this.underlay.addEventListener('click', function() {
      this.hideDrawer();
    }.bind(this));
  }

  showDrawer() {
    this.drawer.classList.remove(classes.displayNone);
    // animates after display none is removed
    setTimeout(() => {
      this.buttons.forEach((el) => el.setAttribute('aria-expanded', true));
      this.drawer.classList.add(classes.isVisible);
      this.drawer.querySelector(selectors.focusable).focus();
      document.addEventListener('focusin', this.watchFocus.bind(this));
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
    }, 1);
  }

  hideDrawer() {
    this.buttons.forEach((el) => el.setAttribute('aria-expanded', true));
    this.drawer.classList.remove(classes.isVisible);
    document.removeEventListener('focusin', this.watchFocus);
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    // adds display none after animations
    setTimeout(() => {
      if (!this.drawer.classList.contains(classes.isVisible)) {
        this.drawer.classList.add(classes.displayNone);
      }
    }, 1200);
  }
}

const drawer = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.drawerWrappper);
    els.forEach(el => {
      sections[this.id].push(new Drawer(el));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(el => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export default drawer;

